import { ThemeProvider } from "@mui/material"
import store, { persistor } from "app/redux/store/store"
import React from "react"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { theme } from "./materialUiTheme"


export const getComponentWithStore = (Component: any, props: any = {}) => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ThemeProvider theme={theme}>
                    {React.isValidElement(Component) ? Component : <Component />}
                </ThemeProvider>
            </PersistGate>
        </Provider>
    )
}